<template>
  <a-layout class="full-height">
    <a-layout>
      <a-layout-sider 
        theme="light"
        :width="220"
        v-model="collapsed" 
        @collapse="isCollapse(collapsed)"
        collapsible>
        <a-menu 
          @click="handleClick" 
          v-model="current" 
          :openKeys.sync="openKeys"
          class="a-menu" 
          :class="{'a-menu-hidden': collapsed === true}" 
          mode="inline">
          <a-sub-menu v-for="v in asideList" :key="v.name" @titleClick="titleClick">
            <span slot="title"
              ><a-icon :type="v.icon" /><span>{{ v.title }}</span></span
            >
            <a-menu-item v-for="item in v.list" :key="item.fullPath">{{ item.name }}</a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout-content class="m-md p-m" systemSetting-content>
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { SYSTEM_SETTING_ASIDELIST } from '@/const/common.js';
import { mapGetters } from 'vuex';
import Event from '@/utils/event';

export default {
  data() {
    return {
      SYSTEM_SETTING_ASIDELIST, // 静态的
      asideList: [], // 动态的
      collapsed: false,
      menuOpenKey: [],
      current: [],
      openKeys: []
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    '$route.path': function() {
      this.setMenuOpenKey();
    }
  },
  methods: {
    initAsideList() {
      // 初始化左侧导航
      this.asideList = [];
      const { permissions } = this.userInfo || {};
      const currentPermission = permissions.filter(item => {
        if (item.fullPath.includes(this.$route.path.split('/')[1]) && item.fullPath !== '/') {
          // 首页为'/'
          return item;
        }
      });
      if (currentPermission) {
        const { children } = currentPermission[0];
        if (children) {
          children.forEach(item => {
            let list = [];
            item.children && (list = item.children.filter(item => item.type === 0));
            this.asideList.push({
              title: item.name,
              name: item.fullPath,
              icon: item.icon,
              list
            });
            // console.log(list)
          });
        }
        // children.forEach(item => {
        //   let list = []
        //   item.children && (
        //     list = item.children.filter(item => item.type===1)
        //   )
        //   console.log(item)
        //   console.log(list)
        // })
      }
    },
    setMenuOpenKey() {
      this.SYSTEM_SETTING_ASIDELIST.forEach(item => {
        let current = item.list.find(v => v.path === this.$route.path);
        if (current) {
          if(!this.collapsed) {
            this.openKeys = [item.name];
            this.current = [current.path];
          }
        }
      });
    },
    handleClick(e) {
      this.$router.push(e.key);
    },
    titleClick(e) {
      this.openKeys = [e.key];
    },
    isCollapse(a){
      if(a === true){
        this.openKeys = [];
      } else {
        this.setMenuOpenKey();
      }
    }
  },
  mounted() {
    this.initAsideList();
    this.setMenuOpenKey();
    Event.$on('setPermission', this.initAsideList);
  },
  beforeDestroy() {
    Event.$off('setPermission', this.initAsideList);
  }
};
</script>

<style lang="less" scoped>
// 设置了fixed之后需要手动设置a-menu宽度
& /deep/ .ant-layout-sider-has-trigger .ant-layout-sider-children {
  height: calc(100vh - 94px);
  position: fixed;
  overflow: auto;
}
.a-menu {
  width: 220px;
  min-height: 100%; // 实现菜单右描边
}
.a-menu-hidden {
  width: 80px;
}
& /deep/ .ant-layout-sider-trigger {
  border: 1px solid #e8e8e8;
}
[systemSetting-content] {
  background: #fff;
}

</style>
